<template>
    <div class="nav-content-wrapper" v-if="!$store.state.waitingRequest">
        <admin-navbar />
        
        <div class="content">
            <h2>Modification du jeu "{{ titre }}"</h2>

            <form action="" method="POST" @submit.prevent="validation">
                <p v-if="erreurTitre">{{ erreurTitre }}</p>
                <label>Titre</label>
                <input type="text" :value="titre" @input="titre= $event.target.value" @focus="erreursTitre" @keyup="erreursTitre" :class="{ border: erreurTitre }" />
                
                <p v-if="erreurTitreUrl">{{ erreurTitreUrl }}</p>
                <label>Titre URL</label>
                <input type="text" :value="titre_url" @input="titre_url= $event.target.value" @focus="erreursTitreUrl" @keyup="erreursTitreUrl" :class="{ border: erreurTitreUrl }" />

                <p v-if="erreurDescription">{{ erreurDescription }}</p>
                <label>Description</label>
                <textarea :value="description" @input="description= $event.target.value" @focus="erreursDescription" @keyup="erreursDescription" :class="{ border: erreurDescription }"></textarea>
                
                <p v-if="erreurUrlIframe">{{ erreurUrlIframe }}</p>
                <label>URL Iframe</label>
                <input type="text" :value="iframe_url" @input="iframe_url= $event.target.value" @focus="erreursUrlIframe" @keyup="erreursUrlIframe" :class="{ border: erreurUrlIframe }" />

                <label>Miniature</label>
                <input type="file" @change="new_image = $event.target.files[0]" accept="image/*" />
                <img :src="'/games/static/miniatures/'+image_url" width="200">
                <p>Le format de l'image doit être, de préférence, de 270 x 196</p>
                
                <label>Catégorie</label>
                <select v-model="id_categorie">
                    <option v-for="cat in lesCategories" :key="cat.id" :value="cat.id">{{ cat.libelle }}</option>
                </select>
                
                <p v-if="erreurTags">{{ erreurTags }}</p>
                <label>Tags</label>
                <input type="text" placeholder="Tags" :value="tags" @input="tags= $event.target.value" @focus="erreursTags" @keyup="erreursTags" :class="{ border: erreurTags }" />

                <label>Visibilité du jeu</label>
                <select v-model="isGamePrivate">
                    <option value="0">Public</option>
                    <option value="1">Privé</option>
                </select>

                <p v-if="viewsError">{{ viewsError }}</p>
                <label>Nombre de vues</label>
                <input type="text" :value="views" @input="views= $event.target.value" @focus="viewsErrors" @keyup="viewsErrors" :class="{ border: viewsError }" />

                <input type="submit" value="Modifier" />

                <p v-if="alerte">{{ alerte }}</p>
            </form>
        </div>
    </div>
</template>

<script>
    import Session from '../mixins/adminSession';
    import AdminNavbar from '../views/AdminNavbar';

    export default {
        name: "AdminEditGame",
        mixins: [Session],
        components: {
            'admin-navbar': AdminNavbar
        },
        data() {
            return {
                id: '',
                titre: '',
                titre_url: '',
                description: '',
                iframe_url: '',
                image_url: '',
                tags: '',
                views: '',
                id_categorie: '',
                isGamePrivate: '',

                bannedUrlTitles: [],

                lesCategories: [],
                new_image: '',
                alerte: '',

                erreurTitre: '',
                erreurTitreUrl: '',
                erreurDescription: '',
                erreurUrlIframe: '',
                erreurTags: '',
                viewsError: '',

                formData: null
            }
        },
        mounted() {
            this.formData = new FormData();
            this.formData.append('data', JSON.stringify({post: "1"}));

            this.bannedUrlTitles = ['categories', 'categorie', 'favoris', 'recherche', 'register', 'login', 'me'];

            this.getGame();
            this.getCategories();
        },
        methods: {
            getGame() {
                let formData = new FormData();
                formData.append('data', JSON.stringify({
                    post: "1",
                    gameTitle: this.$route.params.gameTitle
                }));

                axios
                .post(this.$store.state.apiUrl+"?request=getGame", formData)
                .then((response) => {
                    if(response.data.id) {
                        this.id = response.data.id;
                        this.titre = response.data.title;
                        this.description = response.data.description;
                        this.titre_url = response.data.title_url;
                        this.iframe_url = response.data.iframe_url;
                        this.image_url = response.data.image_url;
                        this.tags = response.data.tags;
                        this.views = response.data.view_count;
                        this.id_categorie = response.data.id_categorie;
                        this.isGamePrivate = response.data.private.toString();
                    }
                    else {
                        this.$router.replace('../editGames');
                    }
                });
            },
            getCategories() {                
                axios
                .post(
                this.$store.state.apiUrl+"?request=getCategories", this.formData
                )
                .then((response) => {
                    if(response.data.length > 0) {
                        this.lesCategories = response.data;
                    }
                });
            },
            titreValide() {
                let valide = false;

                if (this.titre && this.titre.trim() && this.titre.length <= 100) {
                    valide = true;
                }
                return valide;
            },
            titreUrlValide() {
                let valide = false;
                let regex = /^[A-Za-z0-9-]+$/;

                if (this.titre_url && this.titre_url.trim() && regex.test(this.titre_url) && this.titre_url.length <= 100 && !this.bannedUrlTitles.includes(this.titre_url)) {
                    valide = true;
                }
                return valide;
            },
            descriptionValide() {
                let valide = false;

                if (this.description && this.description.trim() && this.description.length <= 1000) {
                    valide = true;
                }
                return valide;
            },
            urlIframeValide() {
                let valide = false;
                let regex = /^(https?):\/\/[^\s]*$/;

                if (this.iframe_url && this.iframe_url.trim() && regex.test(this.iframe_url) && this.iframe_url.length <= 2000) {
                    valide = true;
                }
                return valide;
            },
            tagsValides() {
                let valide = false;
                
                if (this.tags && this.tags.trim() && this.tags.length <= 150) {
                    valide = true;
                }
                return valide;
            },
            viewsValid() {
                let valide = false;
                let regex = /^[0-9]+$/;

                if (this.views && this.views.trim() && regex.test(this.views)) {
                    valide = true;
                }
                return valide;
            },
            erreursTitre() {
                this.erreurTitre = '';

                if (!this.titreValide()) {
                    if (!this.titre || !this.titre.trim()) {
                        this.erreurTitre = 'Le titre est requis.';
                    } else {
                        if (this.titre.length > 100) {
                            this.erreurTitre = 'Le titre ne doit pas dépasser 100 caractères.';
                        }
                    }
                }
            },
            erreursTitreUrl() {
                this.erreurTitreUrl = '';

                if (!this.titreUrlValide()) {
                    if (!this.titre_url || !this.titre_url.trim()) {
                        this.erreurTitreUrl = 'Le titre URL est requis.';
                    } else {
                        let regex = /^[A-Za-z0-9-]+$/;
                        if (!regex.test(this.titre_url)) {
                            this.erreurTitreUrl = "Le titre URL n'est pas valide";
                        }
                        if(this.titre_url.length > 100) {
                            this.erreurTitreUrl = 'Le titre URL ne doit pas dépasser 100 caractères.';
                        }
                        if(this.bannedUrlTitles.includes(this.titre_url)) {
                            this.erreurTitreUrl = 'Le titre URL doit être différent.';
                        }
                    }
                }
            },
            erreursDescription() {
                this.erreurDescription = '';

                if (!this.descriptionValide()) {
                    if (!this.description || !this.description.trim()) {
                        this.erreurDescription = 'La description est requise.';
                    } else {
                        if (this.description.length > 1000) {
                            this.erreurDescription = "La description ne doit pas dépasser 1000 caractères.";
                        }
                    }
                }
            },
            erreursUrlIframe() {
                this.erreurUrlIframe = '';

                if (!this.urlIframeValide()) {
                    if (!this.iframe_url || !this.iframe_url.trim()) {
                        this.erreurUrlIframe = "L'URL de l'Iframe est requise.";
                    } else {
                        let regex = /^(https?):\/\/[^\s]*$/;
                        if (!regex.test(this.iframe_url)) {
                            this.erreurUrlIframe = "L'URL de l'Iframe n'est pas une URL valide.";
                        }
                        if (this.iframe_url.length > 2000) {
                            this.erreurUrlIframe = "L'URL de l'Iframe ne doit pas dépasser 2000 caractères.";
                        }
                    }
                }
            },
            erreursTags() {
                this.erreurTags = '';

                if (!this.tagsValides()) {
                    if (!this.tags || !this.tags.trim()) {
                        this.erreurTags = "Au moins un tag est requis.";
                    } else {
                        if (this.tags.length > 150) {
                            this.erreurTags = "Les tags ne doivent pas dépasser 150 caractères.";
                        }
                    }
                }
            },
            viewsErrors() {
                this.viewsError = '';

                if (!this.viewsValid()) {
                    if (!this.views || !this.views.trim()) {
                        this.viewsError = "Le nombre de vues est requis.";
                    } else {
                        let regex = /^[0-9]+$/;
                        if (!regex.test(this.views)) {
                            this.viewsError = "Le nombre de vues doit être numérique.";
                        }
                    }
                }
            },
            validation() {
                if (this.titreValide() && this.titreUrlValide() && this.descriptionValide() && this.urlIframeValide() && this.tagsValides() && this.viewsValid()) {
                    this.editGame();
                } else {
                    this.erreursTitre();
                    this.erreursTitreUrl();
                    this.erreursDescription();
                    this.erreursUrlIframe();
                    this.erreursTags();
                    this.viewsErrors();
                }
            },
            editGame() {
                let data = JSON.stringify({
                    post: '1',
                    id: this.id,
                    title: this.titre,
                    title_url: this.titre_url,
                    description: this.description,
                    iframe_url: this.iframe_url,
                    image_url: this.image_url,
                    tags: this.tags,
                    views: this.views,
                    id_categorie: this.id_categorie,
                    isGamePrivate: this.isGamePrivate
                });
                
                let formData = new FormData();
                formData.append('data', data);

                // Une nouvelle image a été sélectionnée
                if(this.new_image) {
                    formData.append('file', this.new_image);
                }
                
                axios
                .post(
                this.$store.state.apiUrl+"?request=updateGame", formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                .then((response) => {
                    if(response.data == 'titleExists') {
                        this.alerte = 'Le jeu ne peut pas être modifié car le titre URL existe déjà';
                    }
                    else if(response.data == 'featured') {
                        this.alerte = 'La visibilité du jeu ne peut pas être définie en privée car le jeu est mis en avant';
                    }
                    else if(response.data == false) {
                        this.alerte = "Le jeu n'a pas été modifié";
                    }
                    else {
                        this.alerte = "Le jeu a bien été modifié";
                        this.image_url = response.data;
                    }
                })
                .catch((error) => this.alerte = "Le jeu n'a pas pu être modifié");
            }
        }
    }
</script>

<style scoped src="@/assets/admin.css">
</style>
